export const getAvatarInitials = (name: string): string => {
  if (!name) return ''

  // Trim and split the name into words
  const words = name.trim().split(/\s+/)

  // Get the first letter of each word (up to 3 words)
  const initials = words.slice(0, 3).map((word) => word[0].toUpperCase())

  return initials.join('')
}
